import React, {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {useLoading} from "../loading/LoadingProvider.tsx";
import {post} from "../../utils/FetchUtil.ts";

interface AuthContextType {
    isAuthLoading: boolean;
    loginDto: LoginInfoDto | undefined | null;
    login: (loginData: LoginInfoDto | undefined | null) => void;
    logout: () => void;
    validLogin: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider:React.FC<AuthProviderProps> = ({children}) => {
    const { showLoading, hideLoading } = useLoading();
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const [loginDto, setLoginDto] = useState<AuthContextType['loginDto']>(undefined);
    const login = (data: LoginInfoDto | undefined | null) => {
        if(data?.logged_in){
            setLoginDto(data);
        }else {
            setLoginDto(undefined);
        }
    }
    const logout = () => {
        setLoginDto(undefined);
    }
    const validLogin = () => {
        setIsAuthLoading(true);
        getLoginSessionInfo()
            .finally(() => setIsAuthLoading(false));
    }
    const getLoginSessionInfo = async () => {
        showLoading();
        try{
            const resData = await post<LoginInfoDto>({
                action: "/api/login/info",
                data: {},
            });
            login(resData);
        }catch(error){
            console.error("セクション情報取得の例外:", error);
            login(undefined);
        }finally {
            hideLoading();
            setIsAuthLoading(false);
        }
    }

    useEffect(() => {
        validLogin();
    }, []);
    const value: AuthContextType = {
        isAuthLoading,
        loginDto,
        login,
        logout,
        validLogin
    }
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if(context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};